module.exports = __webpack_public_path__ + "img/vertical_3_5_9006.8263dc49.png";